// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateTestamentaryEntityInput;
  acknowledgeSuggestionsInput: Array<Types.AcknowledgeAiSuggestionInput> | Types.AcknowledgeAiSuggestionInput;
}>;


export type UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation = { __typename?: 'Mutation', updateTestamentaryEntity: { __typename?: 'TestamentaryEntity', id: string }, acknowledgeAISuggestions: Array<{ __typename?: 'AISuggestion', id: string, acceptanceStatus?: Types.AiSuggestionAcceptanceStatus | null }> };

export const Operations = {
  Mutation: {
    UpdateTestamentaryEntityAndAcknowledgeSuggestions: 'UpdateTestamentaryEntityAndAcknowledgeSuggestions' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const UpdateTestamentaryEntityAndAcknowledgeSuggestionsDocument = gql`
    mutation UpdateTestamentaryEntityAndAcknowledgeSuggestions($input: AugmentedUpdateTestamentaryEntityInput!, $acknowledgeSuggestionsInput: [AcknowledgeAISuggestionInput!]!) {
  updateTestamentaryEntity(input: $input) {
    id
  }
  acknowledgeAISuggestions(input: $acknowledgeSuggestionsInput) {
    id
    acceptanceStatus
  }
}
    `;
export type UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutationFn = Apollo.MutationFunction<UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation, UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutationVariables>;

/**
 * __useUpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation__
 *
 * To run a mutation, you first call `useUpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTestamentaryEntityAndAcknowledgeSuggestionsMutation, { data, loading, error }] = useUpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *      acknowledgeSuggestionsInput: // value for 'acknowledgeSuggestionsInput'
 *   },
 * });
 */
export function useUpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation, UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation, UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutationVariables>(UpdateTestamentaryEntityAndAcknowledgeSuggestionsDocument, options);
      }
export type UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutationHookResult = ReturnType<typeof useUpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation>;
export type UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutationResult = Apollo.MutationResult<UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation>;
export type UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutationOptions = Apollo.BaseMutationOptions<UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutation, UpdateTestamentaryEntityAndAcknowledgeSuggestionsMutationVariables>;